<template>
  <div class="logistics">
    <GlobTopNav title="物流详情" :rightHidden="false"> </GlobTopNav>

    <div class="van-content">
      <div class="card">
        <span style="display: inline-block; line-height: 0.29rem; height: 0.29rem">
          快递公司：{{ datas.name }}
        </span>
        <span style="display: inline-block; line-height: 0.29rem; height: 0.29rem">
          快递单号：{{ datas.code }}
        </span>
      </div>

      <div v-if="data != null" class="order-track">
        <!-- <div style="background: #fff"> 订单追踪 </div> -->
        <van-steps direction="vertical" :active="0" active-color="#06bf04">
          <van-step v-for="(items, index) in data" :key="items.id">
            <p :class="{ context: true, 'theme-col': index == 0 }">{{ items.context }}</p>
            <p :class="{ time: true, 'theme-col': index == 0 }">{{ items.time }}</p>
          </van-step>
        </van-steps>
        <div
          v-if="data == null"
          style="text-align: center; font-size: 0.24rem; line-height: 0.5rem"
        >
          当前没有最新的物流信息哦
        </div>
      </div>
      <div class="nodata text-cent" v-if="datas.name == '无须快递'">
        <img src="./../../../assets/img/wlxx-null.png" />
        <span class="text">无须快递~</span>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/topnav'
export default {
  name: 'logistics',
  components: {
    TopNav
  },
  data() {
    return {
      datas: '',
      data: [],
      orderId: this.$route.query.orderid
    }
  },
  methods: {
    goBack: function () {
      history.back(-1)
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay()
    },
    getDatas: function () {
      var isUser = localStorage.getItem('BLHuser')
      var mallid = localStorage.getItem('mallid')
      this.$api.post(
        'order/orders/logistics',
        { id_example: mallid, token_user: isUser, company_id: this.orderId },
        res => {
          if (res.data.code == '100') {
            this.datas = res.data.data
            var _this = this
            if (res.data.data.item.length != 0) {
              for (let i = 0; i < res.data.data.item.length; i++) {
                _this.data.unshift(res.data.data.item[i])
              }
            } else {
              _this.data = null
            }

          } else {
            this.$toast(res.data.message)
          }
        }
      )
    }
  },
  mounted() {
    this.getDatas()
  }
}
</script>

<style lang="less">
.logistics {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;

  .van-step--vertical::after {
    border: none;
  }

  .van-content {
    .card {
      height: 1.88rem;
      box-sizing: border-box;
      padding: 0.5rem 0.3rem;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      span {
        font-size: 0.28rem;
        font-weight: 400;
        color: #262626;
        line-height: 0.48rem;
      }
    }

    .order-track {
      margin-top: 0.2rem;
      padding: 0 0.2rem;
      background-color: #fff;

      .context {
        font-size: 0.26rem;
        font-weight: 400;
        color: #262626;
        line-height: 0.36rem;
        padding-left: 0.2rem;
      }

      .time {
        font-size: .24rem;
        font-weight: 400;
        color: #929292;
        line-height: .42rem;
        padding-left: 0.2rem;
        padding-top: 0.1rem;
      }

      .van-step__circle-container {
        .van-step__circle {
          width: 0.28rem;
          height: 0.28rem;
        }
        i {
          font-size: 0.32rem;
        }
      }

      .van-step__line {
        width: 0.08rem;
        left: -0.31rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/myorder/logistics.vue